import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { connect } from 'react-redux';

class NameLinks extends Component {
  state = {
    links: [{name: 'Bio', last: false},{name: 'Work', last: false},{name: 'Contact', last: true}]
  }

  changePanel = (event) => {
    event.preventDefault();
    const val = event.target.id;
    this.props.OnPanelChanger(val);
  }

  render() {
    return (
      <div className={`${css(styles.nameContainerStyle)} container col-md-5 offset-md-7`} >

          <div className="row justify-content-right col-10 offset-1 col-md-12 offset-md-0">
            <p className={css(styles.nameStyle)} >Mark Holthaus</p>
          </div>
          <div className={`${css(styles.titleDivStyle)} row justify-content-right col-10 offset-1 col-md-12 offset-md-0`}>
            <p>frontend web developer</p>
          </div>
          <div className={`${css(styles.linksDivStyle)} row col-10 offset-1 offset-md-0`}>
            {this.state.links.map(link => {
              return (
                <div className={`${css(styles.linkStyle)} col-4`} key={link.name} >
                  <p onClick={this.changePanel} id={link.name}>{link.name}</p>
                </div>
              )
            })}
          </div>
      </div>
    )
  }
}

const styles = StyleSheet.create({
  nameContainerStyle:{
    paddingTop: '15vh',
    paddingLeft: '1vw',
    paddingRight: '1vw',
    color: '#f5b779',
    '@media (max-width: 767px)': {
      paddingTop: '10vh'
    }
  },
  nameStyle: {
    fontFamily: 'Squada One',
    '@media (min-width: 1370px)': {
      fontSize: '6em'
    },
    '@media (max-width: 1369px)': {
      fontSize: '5em'
    },
    '@media (max-width: 1153px)': {
      fontSize: '4em'
    },
    '@media (max-width: 938px)': {
      fontSize: '3em'
    }
  },
  titleDivStyle: {
    paddingBottom: '2vh',
    '@media (min-width: 1370px)': {
      fontSize: '2.5em'
    },
    '@media (max-width: 1369px)': {
      fontSize: '2em'
    },
    '@media (max-width: 1153px)': {
      fontSize: '1.5em'
    }
  },
  linksDivStyle: {
    borderTop: 'solid #f5b779 1px',
    paddingTop: '2vh'
  },
  linkStyle: {
    fontFamily: 'Lato',
    paddingTop: '1vh',
    ':hover': {
        color:'#ff9c23',
        cursor:'pointer'
    },
    '@media (min-width: 1370px)': {
      fontSize: '1.75em'
    },
    '@media (max-width: 1369px)': {
      fontSize: '1.5em'
    },
    '@media (max-width: 1153px)': {
      fontSize: '1.25em'
    }
  }
})

const mapStateToProps = state => {
  return {
    panelContent: state.panelContent
  }
}

const mapDispatchToProps = dispatch => {
  return {
    OnPanelChanger: (val) => dispatch({type: 'CHANGE_PANEL', payload: val}),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NameLinks);



// WEBPACK FOOTER //
// ./src/components/name/name.js